import { h, Fragment } from 'preact';
import { formatMoney } from 'utils/storefront/format-resource';
import { useMemo } from 'preact/hooks';
import { getProductLabel } from 'utils/helpers';
import useDiscountProduct from '../product-discounts/product-discount';

const ProductPrice = ({
  product,
  variant,
  saleClass,
  compareClass,
  showRange = true,
  showLabel = true,
  ...props
}) => {
  const label = getProductLabel(product.tags || []);
  const inlineDiscount = useDiscountProduct(
    product.id,
    variant?.price?.amount || product?.priceRange.minVariantPrice.amount,
    product.collectionsId,
  );
  const {
    price,
    compareAtPrice,
    showCompareAt,
    discountApplied,
    beforeDiscountPrice,
    discount,
  } = useMemo(() => {
    const data = window.getDiscountData(product, inlineDiscount, variant);
   if(data.discountApplied || data.showCompareAt) {
     data.discount = (
       <span className={saleClass}>
          {window.TMW.Strings.product.priceDiscount.replace(
            '{{amount}}',
            `${data.discountPercentage}%`,
          )}
        </span>
     );
   }
    return data;
  },
    [product, variant, inlineDiscount]);

  return (
    <p {...props}>
      <span className="price">
        {formatMoney(price, false)}
        {!!product &&
          showRange &&
          product.priceRange.minVariantPrice.amount <
            product.priceRange.maxVariantPrice.amount && (
            <>
              {' - '}
              {formatMoney(product.priceRange.maxVariantPrice, false)}
            </>
          )}
      </span>
      {!!beforeDiscountPrice && discountApplied && (
        <>
          <del className={compareClass}>
            {formatMoney(beforeDiscountPrice, false)}
          </del>
        </>
      )}
      {!!discount && showCompareAt && (
        <>
          <del className={compareClass}>
            {formatMoney(compareAtPrice, false)}
          </del>
        </>
      )}
      {!!discount && <>{discount}</>}
      {showLabel && !!label && (
        <div className="body-3 text-misc-sale">{label}</div>
      )}
    </p>
  );
};

export default ProductPrice;
